<script>
  import PaxraySmallLogo from "lib/components/common/logos/PaxraySmallLogo.svelte";
  import PaxrayLogoColorIndependent from "lib/components/common/logos/PaxrayLogoColorIndependent.svelte";

  /**
   * @type {boolean} - Whether to display the full logo or the collapsed logo
   * @default false
   */
  export let full = false;

  /**
   * @type {string} - The color of the logo
   * @default '#FF5F1F'
   */
  export let color = "#FF5F1F";
</script>

<!-- 
   @component This Atom can be either the full logo or the collapsed logo, depending on the exposed prop `full: boolean = false`
 -->

<div>
  {#if full}
    <PaxrayLogoColorIndependent {color} />
  {:else}
    <PaxraySmallLogo />
  {/if}
</div>

<style>
  div {
    width: 100%;
    height: 100%;
    position: relative;
  }
</style>
